import React, { useState } from "react";

import { Button, Skeleton, SpinnerLoader, EmptyBlock } from "components";
import { getFullName } from "helpers";
import { useLoader } from "hooks";
import {
	useGetFusionAuthUsersQuery,
	useLinkFusionAuthUserMutation,
} from "queries";

import styles from "./ssoIdUsersModal.module.scss";

type UnlinkedUsersTableProps = {
	userId: string;
	hideModal: Function;
	refetchUser?: Function;
};

const UnlinkedUsersTable = ({
	userId,
	hideModal,
	refetchUser,
}: UnlinkedUsersTableProps) => {
	const [selectedUserId, setSelectedUserId] = useState<
		string | null | undefined
	>(null);

	const { data: users, isLoading: isLoadingUsers } =
		useGetFusionAuthUsersQuery({ userId });

	const { mutate: linkUser, isLoading: isLoadingLinkUser } =
		useLinkFusionAuthUserMutation({
			userId,
			onSuccess: () => {
				hideModal();
				refetchUser?.();
			},
		});

	const Loader = useLoader(isLoadingUsers);

	const correctedUsers =
		selectedUserId && isLoadingLinkUser
			? users?.filter(({ id }) => id === selectedUserId)
			: users;

	return (
		<Loader
			skeleton={<Skeleton height={105} />}
			component={
				users?.length > 0 ? (
					<ul className={styles.ssoIdUsersList}>
						{correctedUsers?.map((user, index) => {
							return (
								<li
									key={index}
									className={styles.ssoIdUsersItem}
								>
									<div>
										<span className={styles.label}>
											{user?.email}
										</span>{" "}
										({getFullName(user)})
									</div>
									<div>
										{isLoadingLinkUser ? (
											<div
												className={
													styles.spinnerWrapper
												}
											>
												<SpinnerLoader />
											</div>
										) : (
											<div className="d-flex align-items-center">
												<div className="vl"></div>
												<Button
													onClick={() => {
														linkUser({
															fusionAuthUserId:
																user?.id,
														});
														setSelectedUserId(
															user?.id,
														);
													}}
													variant="secondary"
													value="Link the user"
													minWidth="120px"
												/>
											</div>
										)}
									</div>
								</li>
							);
						})}
					</ul>
				) : (
					<EmptyBlock />
				)
			}
		/>
	);
};

export default UnlinkedUsersTable;
